import React, { createContext, useContext, ReactNode, useRef } from 'react'
import { useTimeoutTimer } from './useTimeoutTimer'

interface TimeoutContextType {
  timeLeft: number
  enableTimeout: (timeout: number, triggerFallback: () => void) => void
}

const TimeoutContext = createContext<TimeoutContextType | undefined>(undefined)

export const useTimeoutContext = () => {
  const context = useContext(TimeoutContext)
  if (!context) {
    throw new Error('useTimeoutContext must be used within a TimeoutProvider')
  }
  return context
}

export const TimeoutProvider = ({ children }: { children?: ReactNode }) => {
  const onTimeoutRef = useRef<() => void | null>(null)

  const { timeLeft, setTimeoutMs } = useTimeoutTimer(onTimeoutRef.current)

  const enableTimeout = (durationMs: number, fallback: () => void) => {
    setTimeoutMs(durationMs)
    onTimeoutRef.current = fallback
  }

  return (
    <TimeoutContext.Provider value={{ timeLeft, enableTimeout }}>
      {children}
    </TimeoutContext.Provider>
  )
}
